const $ = require('jquery')
const Promise = require('bluebird')

const niceScroll = (self = $(document)) => new Promise((resolve, reject) => {
    const $el = $('body')

    $el.scrollspy({ target: '#menu-imovel-nav', 'offset': 150 })

    self.find('.nice-scroll-nav a[href^="#"]').click(function () {
        const el = $(this)
        const href = el.attr('href')

        try {
            const $target = $(href)
            if ($target.length) {
                $(window).animate({
                    scrollTop: $target.offset().top - 75
                }, 500, function () {
                    history.pushState(null, el.text(), href)
                })
            } else {
                $(this).blur()
            }
        } catch (err) {
        }
        return false
    })

    $el.scrollspy('refresh')
    $el.scroll()

    resolve()
})

module.exports = niceScroll



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/ui/nice-scroll.js